import api from "./api.js";

// Always return just the user object, no matter if the backend returns { user } or plain object
export const getProfile = async () => {
  const { data } = await api.get("/user/me");
  return data?.user ?? data ?? null;
};

export const updateEmail = async (email) => {
  const { data } = await api.put("/user/email", { email });
  // Some backends return { user, message }, others only user
  return {
    user: data?.user ?? null,
    message: data?.message ?? "Email updated",
  };
};

export const updateUsername = async (username) => {
  const { data } = await api.put(
    "/user/username",
    { username },
    { withCredentials: true }
  );
  return data; // { message, user }
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const { data } = await api.put("/user/password", {
    currentPassword,
    newPassword,
  });
  return { ok: true, message: data?.message ?? "Password updated" };
};
